<!-- <div class="card">
    <div class="card-header card-header-squirrel">
        <h4>{{this.translate.data['TOOLTIPCLONEPROJECT'] | translate}}</h4>
    </div>
    <div class="card-body">
        <form [formGroup]="cloneProjectForm">
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="{{this.translate.data['INPUTPROJECTNAME'] | translate}}" formControlName="name" required>
                                <button mat-button  matSuffix mat-icon-button (click)="createCloneProject()"> 
                                    <mat-icon>add</mat-icon>
                                </button>
                    </mat-form-field>
                </div>
            </div>            
        </form>
    </div>    
</div> -->

<div class="card">
    <div class="card-header card-header-squirrel">
        <h4>Projekt {{this.data[0].display_Name}} kopieren</h4>
        <!-- <h4>{{this.translate.data['TOOLTIPREMOVEUSER'] | translate}}</h4> -->
    </div>

    <div class="card-body">
        <form [formGroup]="cloneProjectForm">
            <mat-form-field class="example-full-width" style="width: 0; height: 0;">
                <input matInput hidden formControlName="id" readonly>
            </mat-form-field>
            <!-- <mat-form-field class="example-full-width" style="width: 0; height: 0;">
                <input matInput hidden formControlName="legacyId" readonly>
            </mat-form-field> -->
            <mat-form-field class="example-full-width" style="width: 0; height: 0;">
                <input matInput hidden formControlName="url" readonly>
            </mat-form-field>
    
            <div class="row">
                <mat-form-field class="example-full-width">
                <input matInput placeholder="{{this.translate.data['INPUTPROJECTNAME'] | translate}}" formControlName="name" required>
                <!-- <button mat-button color="primary"  matSuffix mat-icon-button (click)="deleteUser(userDto.id)"> 
                    <mat-icon>delete</mat-icon>
                </button> -->
                </mat-form-field>
            </div>
            <div class="row">
                <div class="col-md-8">
                    <section class="example-full-width">
                        <mat-slide-toggle color="primary" formControlName="withoutContent" labelPosition="after">
                            <!-- {{this.translate.data['EMAILCONFIRMED'] | translate}} -->
                             ohne Inhalt kopieren ("leeres" Projekt)
                        </mat-slide-toggle>
                    </section>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8">
                    <section class="example-full-width">
                        <mat-slide-toggle color="primary" formControlName="copyGrouproles" labelPosition="after">
                            <!-- {{this.translate.data['EMAILCONFIRMED'] | translate}} -->
                             Projektgruppenrollen kopieren
                        </mat-slide-toggle>
                    </section>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8">
                    <section class="example-full-width">
                        <mat-slide-toggle color="primary"  formControlName="copyUsers" labelPosition="after">
                            <!-- {{this.translate.data['PHONENUMBERCONFIRMED'] | translate}} -->
                            Projektgruppenrollen und Benutzer kopieren
                        </mat-slide-toggle>
                    </section>                        
                </div>
            </div>

            <div class="row">
                <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                    (click)="cancel()" >Abbruch</button>
                </a>                                                
                <span style="flex: 1 1 auto"></span>
                <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPCLONEPROJECT'] | translate}}"
                                    (click)="createCloneProject()" >Kopieren</button>
                </a>                   
            </div>    

    <!-- <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="Dialog schließen"
                (click)="cancel()" >Abbruch</button>
            <button  mat-raised-button class="btn btn-squirrel pull-right" (click)="createCloneProject()" color="primary">Kopieren</button> -->
        </form>
    </div>
</div>